import { gql } from '@apollo/client'

const PATCH_EVENT = gql`
  mutation patchEvent($event: EventInput!) {
    patchEvent(event: $event) {
      message
      statusCode
      code
      error
    }
  }
`

export const CREATE_UPDATE_EVENT = gql`
  mutation upsertEvent($event: EventInput!) {
    upsertEvent(event: $event) {
      message
      statusCode
      code
      error
    }
  }
`

export default PATCH_EVENT
